import { render, staticRenderFns } from "./reset-pw.vue?vue&type=template&id=5849ff28&scoped=true&"
import script from "./reset-pw.vue?vue&type=script&lang=js&"
export * from "./reset-pw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5849ff28",
  null
  
)

export default component.exports